import React, { useEffect } from "react";
import { Modal, Form, Input, Row, Col, Card, Switch } from "antd";
import { EtapeService } from "../../services/EtapeService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";

const EtapeEditForm = ({ visible, uid, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [editing, setEditing] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  useEffect(() => {
    if (uid) {
      setEditing(true);
      EtapeService.getInstance()
        .find(uid)
        .then((response) => {
          form.setFieldsValue(response.data);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setEditing(false);
        });
    }
  }, [uid, form]);

  const handleSave = () => {
    setEditing(true);
    form
      .validateFields()
      .then((values) => {
        EtapeService.getInstance()
          .update(uid, values)
          .then((response) => {
            Toast.success(response.message);
            onUpdate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setEditing(false);
          });
      })
      .catch(() => {
        setEditing(false);
      });
  };

  return (
    <Modal
      width={"50%"}
      open={visible}
      onCancel={onCancel}
      okText="Enregistrer"
      onOk={handleSave}
      title="Modifier etape"
      forceRender
    >
      <Card loading={editing} style={{ marginBottom: 20 }}>
        <Form
          layout="vertical"
          form={form}
          name="editEtapeForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Description"
                name="description"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input.TextArea rows={5} />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Statut"
                name="enabled"
                rules={[{ required: true, message: "Veuillez définir le statut" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default EtapeEditForm;

EtapeEditForm.propTypes = {
  visible: PropTypes.bool,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  uid: PropTypes.string.isRequired
};
